import { FC } from 'react'
import { Link } from 'react-router-dom'

import { SectionLayout } from 'components/layouts'

import GalleryOne from 'assets/images/gallery/galleryOne.webp'
import GalleryThree from 'assets/images/gallery/galleryThree.webp'
import { ReactComponent as ArrowIcon } from 'assets/svg/arrow.svg'

import styles from './PastEvents.module.scss'

type TPastEventsProps = {
  addToRefs?: (el: HTMLDivElement) => void
}

const pastEventsData = [
  {
    id: '2025',
    year: '2025',
    image: GalleryThree,
    link: '/events/2025',
  },
  {
    id: '2024',
    year: '2024',
    image: GalleryOne,
    link: '/events/2024',
  },
]

const PastEvents: FC<TPastEventsProps> = ({ addToRefs }) => {
  const renderPastEvents = pastEventsData.map(({ id, year, image, link }) => (
    <Link key={id} to={link} target='_blank' rel='noreferrer' className={styles.wrapper__card}>
      <img src={image} alt={`AWS Community Day ${year}`} />
      <div className={styles.wrapper__card_overlay}>
        <p>AWS Community Day {year}</p>
        <span>
          View event
          <ArrowIcon />
        </span>
      </div>
    </Link>
  ))

  return (
    <SectionLayout id='PAST-EVENTS' className={styles.wrapper} addToRefs={addToRefs}>
      <div className='container'>
        <h2 className={styles.wrapper__title}>Past Events</h2>
        <div className={styles.wrapper__list}>{renderPastEvents}</div>
      </div>
    </SectionLayout>
  )
}

export default PastEvents
